"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInvoiceText = void 0;
const sha_js_1 = require("sha.js");
const luxon_1 = require("luxon");
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const pdf_1 = require("./utils/pdf");
const markets_1 = __importStar(require("./market/markets"));
const datetime_1 = require("./utils/datetime");
const array_1 = require("./utils/array");
const hashInvoice = (name, shifts, adjustments) => new sha_js_1.sha256()
    .update(JSON.stringify({
    name,
    shifts,
    adjustments,
}))
    .digest('hex');
const detectLocale = (text) => {
    const [locale] = Object.entries(markets_1.default)
        .find(([_locale, { flags }]) => (flags.with.every((flag) => text
        .some((line) => line.includes(flag)))
        && (flags.not || []).every((flag) => text
            .every((line) => !line.includes(flag))))) || [];
    return locale;
};
const parseInvoiceText = (text, knownLocale = undefined, timezone = undefined, progress = null) => __awaiter(void 0, void 0, void 0, function* () {
    const locale = knownLocale || detectLocale(text);
    if (locale === undefined) {
        throw new Error('No known market detected');
    }
    const zone = timezone || markets_1.defaultTimezones[locale];
    let shifts = [];
    let adjustments = [];
    let period = {
        start: luxon_1.DateTime.now(),
        end: luxon_1.DateTime.now(),
    };
    let name = '';
    let error = '';
    const parser = markets_1.default[locale];
    try {
        const args = { text, zone };
        const [parsedName, parsedPeriod, parsedShifts, parsedAdjustments,] = yield Promise.all([
            parser.getName(args),
            parser.getPeriod(args),
            parser.getShifts(args),
            parser.getAdjustments(args),
        ]);
        name = parsedName;
        period = parsedPeriod;
        shifts = sortBy_1.default(parsedShifts.map((shift) => (Object.assign(Object.assign({}, shift), { hours: datetime_1.getShiftHours(shift.start, shift.end) }))), (shift) => shift.start.toMillis());
        adjustments = sortBy_1.default(parsedAdjustments, ['label']);
    }
    catch (e) {
        const { stack, name: errorName, message } = e;
        error = stack || `${errorName}: ${message}`;
    }
    if (progress) {
        progress.increment();
    }
    return Object.assign(Object.assign({ name }, period), { shifts,
        adjustments,
        error, currency: parser.currency, locale, hash: error === '' ? hashInvoice(name, shifts, adjustments) : '' });
});
exports.parseInvoiceText = parseInvoiceText;
const parseInvoicePdf = (data, knownLocale = undefined, timezone = undefined, progress = null) => __awaiter(void 0, void 0, void 0, function* () {
    const text = yield pdf_1.getPdfText(data);
    return exports.parseInvoiceText(array_1.clean(text), knownLocale, timezone, progress);
});
exports.default = parseInvoicePdf;
//# sourceMappingURL=parse.js.map